module.exports = __webpack_public_path__ + "static/hot-a848957c93baf07fba1ef7d88a7d8016.png";